import { useParams } from "react-router-dom";
import { CaseStudyTemplate } from "@/components/detail/CaseStudyTemplate";
import { getCaseStudy } from "@/data/caseStudies.data";
import NotFound from "@/pages/NotFound";

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const data = getCaseStudy(slug);
  if (!data) return <NotFound />;
  return <CaseStudyTemplate caseStudy={data} />;
}
